export default "__VITE_ASSET__e652052c__"